import { clearGridCache } from "../versioning/scripts"
import { VersionManager } from "../versioning/version-manager"

export function useAppSetup() {
  VersionManager.registerUpdate("1.0.0", { clearGridCache })
  // Run all updates
  VersionManager.upgrade()
}
